var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMucoLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 537.333,
    height: 80,
    viewBox: "0 0 537.333 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fcdd2e;\n      }\n\n      .cls-2 {\n        fill: #709952;\n      }\n\n      .cls-3, .cls-6 {\n        fill: #fff;\n        stroke: #000;\n        stroke-miterlimit: 10;\n        stroke-width: 13px;\n      }\n\n      .cls-3 {\n        stroke-linecap: round;\n      }\n\n      .cls-4 {\n        fill: #afbd36;\n      }\n\n      .cls-5 {\n        fill: #c5e0a9;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_218",
    "data-name": "Group 218",
    transform: "translate(-599 -160)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    "data-name": "Union 2",
    className: "cls-1",
    d: "M59.811,5.268a13.626,13.626,0,0,1,21.2-.409l4.327,5.095c-3.3,2.837-31.612,28.514-8.669,55.961L59.8,80C36.289,51.878,46.231,23.22,59.811,5.268ZM8.639,65.914C32.178,37.758,1.323,11.1,0,9.978L4.3,4.9a13.627,13.627,0,0,1,21.213.39C39.082,23.248,49,51.891,25.5,80Z",
    transform: "translate(824.333 160)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_1",
    "data-name": "Union 1",
    className: "cls-2",
    d: "M133.288,42.588a17.747,17.747,0,0,1-7.455-7.824A27.688,27.688,0,0,1,123.32,22.4a24.773,24.773,0,0,1,2.736-12.143,18.661,18.661,0,0,1,7.77-7.6A23.323,23.323,0,0,1,144.875,0a28.285,28.285,0,0,1,6.737.767,16.462,16.462,0,0,1,5.3,2.2,8.1,8.1,0,0,1,2.379,2.065,4.066,4.066,0,0,1,.672,2.339,8.047,8.047,0,0,1-.806,3.1,14.349,14.349,0,0,1-2.066,3.374,14.13,14.13,0,0,0-4.625-3.283,13.729,13.729,0,0,0-5.792-1.3q-5.393,0-8.176,3.282t-2.783,9.671q0,6.748,2.739,10.3t8.13,3.556a13.837,13.837,0,0,0,5.749-1.217,11.253,11.253,0,0,0,4.222-3.1,13.216,13.216,0,0,1,2.066,3.238,8.415,8.415,0,0,1,.988,3.418,4.276,4.276,0,0,1-1.888,3.507q-4.49,3.423-12.843,3.42A23.471,23.471,0,0,1,133.288,42.588Zm36.6-3.46q-5.521-6.027-5.522-16.553A25.264,25.264,0,0,1,167.1,10.569,18.985,18.985,0,0,1,174.649,2.7,22.466,22.466,0,0,1,185.83,0q10.06,0,15.449,5.89t5.387,16.417a27.676,27.676,0,0,1-2.56,12.322,17.645,17.645,0,0,1-7.274,7.87,22.855,22.855,0,0,1-11.362,2.655Q175.411,45.154,169.886,39.128Zm9.027-26.267q-2.336,3.509-2.334,9.626,0,6.475,2.289,9.982a7.412,7.412,0,0,0,6.6,3.509q8.892,0,8.891-13.583,0-13.04-8.712-13.042A7.6,7.6,0,0,0,178.913,12.861Zm-99.156,29.5a10.562,10.562,0,0,1-4.313-6.923,44.54,44.54,0,0,1-.719-9.264V1.258a11.827,11.827,0,0,1,1.615-.224C77.241.943,78.079.9,78.86.9q8.085,0,8.083,7.106V25.634a20.578,20.578,0,0,0,.585,5.937A4.22,4.22,0,0,0,89.5,34.043a7.959,7.959,0,0,0,3.819.767,11.008,11.008,0,0,0,5.745-1.394,4.033,4.033,0,0,0,2.336-3.462V1.258a11.76,11.76,0,0,1,1.615-.224Q104.364.9,105.534.9a8.5,8.5,0,0,1,6.017,1.933,7.337,7.337,0,0,1,2.068,5.625V43.8h-8.176a3.233,3.233,0,0,1-2.649-.946q-.761-.942-.762-3.822-4.133,5.58-13.2,5.578Q83.08,44.615,79.758,42.363ZM51.015,43.8V18.978a22.117,22.117,0,0,0-.492-5.71,3.981,3.981,0,0,0-1.8-2.339,7.226,7.226,0,0,0-3.636-.767,10.3,10.3,0,0,0-4.313.99,6.813,6.813,0,0,0-3.055,2.429,49.817,49.817,0,0,1,.27,5.306V43.8H25.777V18.978a20.6,20.6,0,0,0-.583-6.026,4.306,4.306,0,0,0-1.932-2.384A7.715,7.715,0,0,0,19.489,9.8,8.917,8.917,0,0,0,14.326,11.2,4.114,4.114,0,0,0,12.3,14.661V43.8H0V1.259l1.077-.181A24.007,24.007,0,0,1,4.04.9q6.648,0,7.634,4.679Q15.8,0,24.879,0a14.484,14.484,0,0,1,6.962,1.485,9.655,9.655,0,0,1,4.177,4.541Q40.865,0,49.67,0q5.658,0,8.979,2.384A9.639,9.639,0,0,1,62.6,9.175a58.531,58.531,0,0,1,.63,9.264V43.8Z",
    transform: "translate(929.667 180)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_217",
    "data-name": "Group 217",
    transform: "translate(599 173.333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    transform: "translate(79.239 9.868)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    className: "cls-3",
    d: "M924.366,557.932",
    transform: "translate(-924.366 -557.932)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_1",
    "data-name": "Subtraction 1",
    className: "cls-4",
    d: "M55,60H5a5.006,5.006,0,0,1-5-5V5A5.006,5.006,0,0,1,5,0H55a5.006,5.006,0,0,1,5,5V55A5.006,5.006,0,0,1,55,60ZM30.227,17.719A12.523,12.523,0,0,1,42.736,30.227V47.6a4.86,4.86,0,1,0,9.719,0V30.227A22.228,22.228,0,1,0,30.227,52.456a4.86,4.86,0,1,0,0-9.719,12.509,12.509,0,0,1,0-25.017Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_3",
    "data-name": "Subtraction 3",
    className: "cls-5",
    d: "M55,60H5a5.006,5.006,0,0,1-5-5V5A5.006,5.006,0,0,1,5,0H55a5.006,5.006,0,0,1,5,5V55A5.006,5.006,0,0,1,55,60ZM32.894,8A22.228,22.228,0,1,0,48.611,45.944a4.86,4.86,0,0,0-6.874-6.871,12.508,12.508,0,1,1-.021-17.711,4.859,4.859,0,1,0,6.855-6.889A22.08,22.08,0,0,0,32.894,8Z",
    transform: "translate(141.333 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_2",
    "data-name": "Subtraction 2",
    className: "cls-2",
    d: "M55,60H5a5.006,5.006,0,0,1-5-5V5A5.006,5.006,0,0,1,5,0H7.772V30.227A22.228,22.228,0,1,0,30,8a4.86,4.86,0,0,0,0,9.719A12.509,12.509,0,1,1,17.492,30.227V0H55a5.006,5.006,0,0,1,5,5V55A5.006,5.006,0,0,1,55,60Z",
    transform: "translate(70.667 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    className: "cls-6",
    d: "M950.376,513.5",
    transform: "translate(-847.907 -503.383)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    className: "cls-3",
    d: "M950.376,513.5",
    transform: "translate(-847.907 -503.383)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMucoLarge);
export default __webpack_public_path__ + "static/media/icon-muco-large.5823a484de33748d6c783ae3f8f4439f.svg";
export { ForwardRef as ReactComponent };